export default "__VITE_ASSET__CYtgmiZd__"